import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICategoryTypeSlice } from "./types";
import { RequestStatus } from "@app/constants";

const initialState: ICategoryTypeSlice = {
  category: {},
  getParentCategory: {},
  addCategory: {},
  deleteCategory: {},
  updateCategory: {},
};

const slice = createSlice({
  name: "categoryTypes",
  initialState,
  reducers: {
    category(state, action: PayloadAction) {
      state.category.status = RequestStatus.RUNNING;
    },
    categorySuccess(state, action) {
      state.category.status = RequestStatus.SUCCESS;
      state.category.data = action.payload;
    },
    categoryFailed(state, action: PayloadAction<any>) {
      state.category.status = RequestStatus.ERROR;
      state.category.error = action.payload;
    },
    getParentCategory(state, action: PayloadAction) {
      state.getParentCategory.status = RequestStatus.RUNNING;
    },
    getParentCategorySuccess(state, action) {
      state.getParentCategory.status = RequestStatus.SUCCESS;
      state.getParentCategory.data = action.payload;
    },
    getParentCategoryFailed(state, action: PayloadAction<any>) {
      state.getParentCategory.status = RequestStatus.ERROR;
      state.getParentCategory.error = action.payload;
    },
    addCategory(state, action: PayloadAction<any>) {
      state.addCategory.status = RequestStatus.RUNNING;
    },
    addCategorySuccess(state, action) {
      state.addCategory.status = RequestStatus.SUCCESS;
      state.addCategory.data = action.payload;
    },
    addCategoryFailed(state, action: PayloadAction<any>) {
      state.addCategory.status = RequestStatus.ERROR;
      state.addCategory.error = action.payload;
    },
    deleteCategory(state, action: PayloadAction<any>) {
      state.deleteCategory.status = RequestStatus.RUNNING;
    },
    deleteCategorySuccess(state, action) {
      state.deleteCategory.status = RequestStatus.SUCCESS;
      state.deleteCategory.data = action.payload;
    },
    deleteCategoryFailed(state, action: PayloadAction<any>) {
      state.deleteCategory.status = RequestStatus.ERROR;
      state.deleteCategory.error = action.payload;
    },
    updateCategory(state, action: PayloadAction<any>) {
      state.updateCategory.status = RequestStatus.RUNNING;
    },
    updateCategorySuccess(state, action) {
      state.updateCategory.status = RequestStatus.SUCCESS;
      state.updateCategory.data = action.payload;
    },
    updateCategoryFailed(state, action: PayloadAction<any>) {
      state.updateCategory.status = RequestStatus.ERROR;
      state.updateCategory.error = action.payload;
    },
  },
});

export const {
  category,
  deleteCategory,
  deleteCategorySuccess,
  deleteCategoryFailed,
  categorySuccess,
  categoryFailed,
  updateCategory,
  updateCategorySuccess,
  updateCategoryFailed,
  addCategory,
  addCategorySuccess,
  addCategoryFailed,
  getParentCategory,
  getParentCategorySuccess,
  getParentCategoryFailed,
} = slice.actions;

export default slice.reducer;
